import { useRealtimeListeners } from './useRealtimeListeners'

export const useVisibilityState = () => {
  const { removeAllListeners, resubscribeAllChannels } = useRealtimeListeners()

  if (!import.meta.client) {
    return {
      isVisible: ref(true),
      wasLastVisible: ref(new Date())
    }
  }

  const isVisible = ref(document.visibilityState === 'visible')
  const wasLastVisible = ref(new Date())

  const handleVisibilityChange = () => {
    const wasVisible = isVisible.value
    isVisible.value = document.visibilityState === 'visible'
    wasLastVisible.value = new Date()

    if (isVisible.value && !wasVisible) {
      console.log('😬 User has returned to the page', new Date().toISOString())
      
      // Check if user was away for more than 30 seconds
      const timeAway = new Date().getTime() - wasLastVisible.value.getTime()
      const thirtySeconds = 30 * 1000
      
      if (timeAway > thirtySeconds) {
        console.log(`User was away for ${Math.round(timeAway / 1000)} seconds, resubscribing to channels...`)
        
        // Wait a moment for the page to fully load, then resubscribe
        setTimeout(() => {
          resubscribeAllChannels()
        }, 1000)
      }

    } else if (!isVisible.value && wasVisible) {
      console.log('👋🏼👋🏼👋🏼👋🏼 User has left the page', new Date().toISOString())
      // Don't remove listeners immediately - let them try to maintain connection
      // removeAllListeners()
    }
  }

  onMounted(() => {
    // Add event listener
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  onUnmounted(() => {
    // Clean up event listener
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })

  return {
    isVisible,
    wasLastVisible
  }
} 